import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag, Mail, Phone, Instagram, Ribbon } from 'lucide-react';
import { useTranslation } from '../i18n/LanguageContext';
export function FinalCtaSection() {
  const {
    t
  } = useTranslation();
  return <section id="contact" className="py-24 bg-white relative" data-id="element-256">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-257">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-258">
          <h2 className="font-serif text-4xl md:text-5xl text-gray-900 mb-8" data-id="element-259">
            {t.finalCta.heading}
          </h2>
          <p className="text-lg text-gray-600 mb-8" data-id="element-260">{t.finalCta.intro1}</p>
          <p className="text-lg text-gray-600 mb-12 max-w-3xl mx-auto" data-id="element-261">
            {t.finalCta.intro2}
          </p>
          <div className="py-8 px-4" data-id="element-262">
            <p className="font-script text-4xl md:text-5xl text-lavender-600 leading-relaxed" data-id="element-263">
              {t.finalCta.quote}
            </p>
          </div>
          <p className="font-serif text-xl text-gray-500 mt-8" data-id="element-264">
            {t.finalCta.tagline}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-cream-50 rounded-3xl p-8 md:p-12 border border-lavender-100 shadow-sm" data-id="element-265">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-sm mb-8" data-id="element-266">
            <Ribbon className="w-8 h-8 text-lavender-500" data-id="element-267" />
          </div>

          <h3 className="font-serif text-3xl text-gray-900 mb-10" data-id="element-268">
            {t.finalCta.cardsHeading}
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-269">
            <a href="#collection" className="bg-white p-6 rounded-2xl border border-lavender-100 hover:border-lavender-300 hover:shadow-md transition-all group text-left flex flex-col h-full" data-id="element-270">
              <div className="flex items-center gap-4 mb-4" data-id="element-271">
                <div className="w-12 h-12 bg-lavender-50 rounded-full flex items-center justify-center group-hover:bg-lavender-100 transition-colors" data-id="element-272">
                  <ShoppingBag className="w-6 h-6 text-lavender-600" data-id="element-273" />
                </div>
                <h4 className="font-serif text-xl font-semibold text-gray-900" data-id="element-274">
                  {t.finalCta.cards.shop.title}
                </h4>
              </div>
              <p className="text-gray-600 text-sm mt-auto" data-id="element-275">
                {t.finalCta.cards.shop.desc}
              </p>
            </a>

            <a href="mailto:ferbystore4@gmail.com" className="bg-white p-6 rounded-2xl border border-lavender-100 hover:border-lavender-300 hover:shadow-md transition-all group text-left flex flex-col h-full" data-id="element-276">
              <div className="flex items-center gap-4 mb-4" data-id="element-277">
                <div className="w-12 h-12 bg-blush-50 rounded-full flex items-center justify-center group-hover:bg-blush-100 transition-colors" data-id="element-278">
                  <Mail className="w-6 h-6 text-blush-600" data-id="element-279" />
                </div>
                <h4 className="font-serif text-xl font-semibold text-gray-900" data-id="element-280">
                  {t.finalCta.cards.custom.title}
                </h4>
              </div>
              <p className="text-gray-600 text-sm mt-auto" data-id="element-281">
                {t.finalCta.cards.custom.desc}
                <br data-id="element-282" />
                <span className="font-medium text-lavender-600 mt-2 block" data-id="element-283">
                  ferbystore4@gmail.com
                </span>
              </p>
            </a>

            <a href="tel:801-716-0058" className="bg-white p-6 rounded-2xl border border-lavender-100 hover:border-lavender-300 hover:shadow-md transition-all group text-left flex flex-col h-full" data-id="element-284">
              <div className="flex items-center gap-4 mb-4" data-id="element-285">
                <div className="w-12 h-12 bg-cream-100 rounded-full flex items-center justify-center group-hover:bg-cream-200 transition-colors" data-id="element-286">
                  <Phone className="w-6 h-6 text-gold-600" data-id="element-287" />
                </div>
                <h4 className="font-serif text-xl font-semibold text-gray-900" data-id="element-288">
                  {t.finalCta.cards.phone.title}
                </h4>
              </div>
              <p className="text-gray-600 text-sm mt-auto" data-id="element-289">
                {t.finalCta.cards.phone.desc}
                <br data-id="element-290" />
                <span className="font-medium text-lavender-600 mt-2 block" data-id="element-291">
                  801-716-0058
                </span>
                <span className="font-medium text-lavender-600 block" data-id="element-292">
                  385-549-3420
                </span>
              </p>
            </a>

            <a href="https://instagram.com/ferby_store4" target="_blank" rel="noopener noreferrer" className="bg-white p-6 rounded-2xl border border-lavender-100 hover:border-lavender-300 hover:shadow-md transition-all group text-left flex flex-col h-full" data-id="element-293">
              <div className="flex items-center gap-4 mb-4" data-id="element-294">
                <div className="w-12 h-12 bg-lavender-50 rounded-full flex items-center justify-center group-hover:bg-lavender-100 transition-colors" data-id="element-295">
                  <Instagram className="w-6 h-6 text-lavender-600" data-id="element-296" />
                </div>
                <h4 className="font-serif text-xl font-semibold text-gray-900" data-id="element-297">
                  {t.finalCta.cards.visit.title}
                </h4>
              </div>
              <p className="text-gray-600 text-sm mt-auto" data-id="element-298">
                {t.finalCta.cards.visit.addr2}
                <br data-id="element-299" />
                <span className="font-medium text-lavender-600 mt-2 block" data-id="element-300">
                  {t.finalCta.cards.visit.addr1}
                </span>
              </p>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}